/* =========================================================================
   Acryhome — theme.js (Shopify OS 2.0)
   Ports the prototype's progressive-enhancement UI and wires it to native
   Shopify APIs: Cart AJAX API (/cart/*.js), Predictive Search
   (/search/suggest.json), and the Customer Privacy API for consent.
   No third-party dependencies. All nav/forms work without JS.
   ========================================================================= */
(function () {
  "use strict";
  var focusable = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];});}
  function money(cents){
    var fmt = (window.theme && theme.moneyFormat) || 'AED {{amount}}';
    var v = (cents / 100);
    var two = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var none = Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount\s*\}\}/g, two)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, none)
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, v.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  }
  function toast(msg){
    var region = document.querySelector('[data-toast-region]');
    if(!region){ region = document.createElement('div'); region.className = 'toast-region'; region.setAttribute('data-toast-region',''); region.setAttribute('aria-live','polite'); document.body.appendChild(region); }
    var el = document.createElement('div'); el.className = 'toast toast--'+(arguments[1]||'success'); el.textContent = msg;
    region.appendChild(el);
    setTimeout(function(){ el.remove(); }, 3200);
  }
  function t(k, d){ return (window.theme && theme.strings && theme.strings[k]) || d || k; }

  /* ---- Accordions ---- */
  document.querySelectorAll('[data-accordion-trigger]').forEach(function (btn) {
    var panel = document.getElementById(btn.getAttribute('aria-controls')); if (!panel) return;
    panel.hidden = btn.getAttribute('aria-expanded') !== 'true';
    btn.addEventListener('click', function () { var o = btn.getAttribute('aria-expanded') === 'true'; btn.setAttribute('aria-expanded', String(!o)); panel.hidden = o; });
  });

  /* ---- Layer manager (drawers/overlays) with focus trap ---- */
  function getFocusable(c){ return Array.prototype.filter.call(c.querySelectorAll(focusable), function(el){ return el.offsetParent!==null||el.getClientRects().length; }); }
  var trap = [];
  function openLayer(el, opener){
    opener = opener || (document.activeElement && document.activeElement !== document.body ? document.activeElement : null);
    el.setAttribute('data-open','true'); el.removeAttribute('hidden');
    var ov = el.getAttribute('data-overlay') && document.getElementById(el.getAttribute('data-overlay')); if(ov) ov.setAttribute('data-open','true');
    document.documentElement.style.overflow='hidden';
    var target = el.querySelector('[data-autofocus]') || getFocusable(el)[0] || el;
    requestAnimationFrame(function(){ target.focus(); });
    var handler=function(e){ if(e.key==='Tab'){ var f=getFocusable(el); if(!f.length){e.preventDefault();return;} var a=f[0],z=f[f.length-1]; if(e.shiftKey&&document.activeElement===a){e.preventDefault();z.focus();} else if(!e.shiftKey&&document.activeElement===z){e.preventDefault();a.focus();} } };
    el.addEventListener('keydown',handler); trap.push({el:el,handler:handler,opener:opener});
    el._esc=function(e){ if(e.key==='Escape') closeLayer(el); }; document.addEventListener('keydown', el._esc);
  }
  function closeLayer(el){
    el.setAttribute('data-open','false');
    var ov = el.getAttribute('data-overlay') && document.getElementById(el.getAttribute('data-overlay')); if(ov) ov.setAttribute('data-open','false');
    document.documentElement.style.overflow=''; if(el._esc) document.removeEventListener('keydown', el._esc);
    var tr=trap.pop(); if(tr){ tr.el.removeEventListener('keydown',tr.handler); if(tr.opener&&tr.opener.focus) tr.opener.focus(); }
  }
  document.addEventListener('click', function(e){
    var o=e.target.closest('[data-open-layer]'); if(o){ var tg=document.getElementById(o.getAttribute('data-open-layer')); if(tg){e.preventDefault(); openLayer(tg,o);} return; }
    var c=e.target.closest('[data-close-layer]'); if(c){ var l=c.closest('[data-open],.drawer,.search-overlay,.modal'); if(l) closeLayer(l); return; }
    var ov=e.target.closest('.overlay[data-closes]'); if(ov){ var l2=document.getElementById(ov.getAttribute('data-closes')); if(l2) closeLayer(l2); }
  });

  /* ---- Quantity steppers ---- */
  document.querySelectorAll('[data-qty]').forEach(function(g){ var i=g.querySelector('input'); if(!i)return; var dec=g.querySelector('[data-qty-dec]'),inc=g.querySelector('[data-qty-inc]'); var min=parseInt(i.min||'1',10);
    function set(v){ i.value=Math.max(min,v||min); } if(dec&&dec.tagName==='BUTTON') dec.addEventListener('click',function(){set(parseInt(i.value,10)-1);}); if(inc&&inc.tagName==='BUTTON') inc.addEventListener('click',function(){set(parseInt(i.value,10)+1);}); });

  /* ---- Char counters ---- */
  document.querySelectorAll('[data-counter]').forEach(function(i){ var o=document.getElementById(i.getAttribute('data-counter')); if(!o)return; var max=parseInt(i.getAttribute('maxlength')||'0',10); function u(){ o.textContent=max?(i.value.length+' / '+max):String(i.value.length); } i.addEventListener('input',u); u(); });

  /* ---- Sticky header shadow + shrink (hysteresis prevents flicker) ---- */
  (function(){ var h=document.querySelector('[data-header]'); if(!h)return; var tick=false; var compact=false;
    window.addEventListener('scroll',function(){ if(!tick){ requestAnimationFrame(function(){
      var y=window.scrollY;
      h.classList.toggle('is-scrolled', y>4);
      if(!compact&&y>72){ compact=true; h.classList.add('is-compact'); }
      else if(compact&&y<16){ compact=false; h.classList.remove('is-compact'); }
      tick=false; }); tick=true; } },{passive:true}); })();

  /* ---- Mega menu ---- */
  (function(){ var items=document.querySelectorAll('[data-nav-item]'); var open=null,timer=null;
    function close(it){ it.classList.remove('is-open'); var tr=it.querySelector('[data-nav-trigger]'); if(tr) tr.setAttribute('aria-expanded','false'); if(open===it)open=null; }
    function show(it){ if(open&&open!==it)close(open); it.classList.add('is-open'); var tr=it.querySelector('[data-nav-trigger]'); if(tr) tr.setAttribute('aria-expanded','true'); open=it; }
    items.forEach(function(it){ var tr=it.querySelector('[data-nav-trigger]'); if(!tr)return; it.addEventListener('mouseenter',function(){clearTimeout(timer);show(it);}); it.addEventListener('mouseleave',function(){timer=setTimeout(function(){close(it);},120);}); tr.addEventListener('click',function(e){e.preventDefault(); it.classList.contains('is-open')?close(it):show(it);}); it.addEventListener('focusout',function(e){ if(!it.contains(e.relatedTarget))close(it); }); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&open){ var tr=open.querySelector('[data-nav-trigger]'); close(open); if(tr)tr.focus(); } });
    document.addEventListener('click',function(e){ if(open&&!open.contains(e.target))close(open); });
  })();

  /* ---- Collection sort (the select rendered with no handler at all) ---- */
  document.querySelectorAll('[data-sort]').forEach(function(sel){
    sel.addEventListener('change', function(){
      var u=new URL(window.location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      window.location.href=u.toString();
    });
  });

  /* ---- Language selector auto-submit ---- */
  document.querySelectorAll('[data-auto-submit]').forEach(function(s){ s.addEventListener('change',function(){ if(s.form) s.form.submit(); }); });

  /* ---- Cart (Shopify Cart AJAX API) ---- */
  /* Every endpoint goes through the locale root: hard-coded "/cart/add.js"
     dropped the /ar prefix, so an Arabic shopper's cart calls (and the
     checkout handoff below) silently flipped the session back to English. */
  var ROOT=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  /* Locale roots can arrive without the trailing slash ("/ar"), which turned
     every call into /arcart/add.js. */
  if(ROOT.slice(-1)!=='/') ROOT+='/';
  var Cart = {
    get: function(){ return fetch(ROOT+'cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}); },
    add: function(form){ return fetch(ROOT+'cart/add.js',{method:'POST',body:new FormData(form),headers:{'Accept':'application/json'}}).then(function(r){return r.json();}); },
    change: function(key,qty){ return fetch(ROOT+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}); }
  };
  function setCount(n){ document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent=n; el.hidden=n===0; }); var lbl=document.querySelector('[data-cart-count-label]'); if(lbl) lbl.textContent=n?('('+n+')'):''; }
  /* The product page sends the chosen finish's photo as properties._image.
     it.image is the variant image, which is the product's first (black) photo
     whatever the finish, so a Gold line looked Black. Only a Shopify CDN
     address is used. */
  function lineImage(it){ var p=it.properties&&it.properties._image; return (typeof p==='string'&&/\/cdn\/shop\/|cdn\.shopify\.com\//.test(p))?p:it.image; }
  function lineHTML(it){ var img=lineImage(it); return '<div class="cart-line" data-line-key="'+esc(it.key)+'"><div class="cart-line__thumb">'+(img?'<img src="'+esc(img)+'" width="96" height="120" alt="'+esc(it.product_title)+'" loading="lazy">':'')+'</div><div class="cart-line__body"><div class="cart-line__top"><h3 class="cart-line__title"><a href="'+esc(it.url)+'">'+esc(it.product_title)+'</a></h3><span class="cart-line__price">'+money(it.final_line_price)+'</span></div>'+(it.variant_title?'<span class="cart-line__meta">'+esc(it.variant_title)+'</span>':'')+propsHTML(it)+'<div class="cart-line__bottom"><div class="qty" data-qty><button type="button" class="qty__btn" data-line-dec="'+esc(it.key)+'" aria-label="'+t('decrease','Decrease')+'">&minus;</button><input class="qty__input" type="number" value="'+it.quantity+'" min="1" data-line-qty="'+esc(it.key)+'"><button type="button" class="qty__btn" data-line-inc="'+esc(it.key)+'" aria-label="'+t('increase','Increase')+'">+</button></div><button type="button" class="cart-line__remove" data-line-remove="'+esc(it.key)+'">'+t('remove','Remove')+'</button></div></div></div>'; }
  function propsHTML(it){ if(!it.properties)return ''; var ks=Object.keys(it.properties).filter(function(k){return k[0]!=='_'&&it.properties[k];}); if(!ks.length)return ''; return '<ul class="cart-line__props">'+ks.map(function(k){return '<li class="cart-line__prop"><b>'+esc(k)+':</b> '+esc(it.properties[k])+'</li>';}).join('')+'</ul>'; }
  function renderProgress(cart){
    var box=document.querySelector('[data-cart-drawer-progress]'); if(!box)return;
    var threshold=(window.theme&&theme.freeDeliveryThreshold)||0;
    if(!threshold||!cart.item_count){ box.innerHTML=''; return; }
    var pct=Math.min(100, Math.round(cart.total_price/threshold*100));
    var msg = cart.total_price>=threshold ? t('free_delivery_unlocked',"You've unlocked free delivery")
      : t('free_delivery_progress','[amount] away from free delivery').replace('[amount]', money(threshold-cart.total_price));
    box.innerHTML='<div class="delivery-progress"><p class="delivery-progress__label">'+esc(msg)+'</p><div class="delivery-progress__track" role="progressbar" aria-valuenow="'+pct+'" aria-valuemin="0" aria-valuemax="100"><div class="delivery-progress__bar" style="inline-size:'+pct+'%"></div></div></div>';
  }
  function renderUpsells(cart){
    var wrap=document.querySelector('[data-cart-upsell]'), items=document.querySelector('[data-cart-upsell-items]'), dataEl=document.querySelector('[data-cart-upsell-data]');
    if(!wrap||!items||!dataEl)return;
    var list=[]; try{ list=(JSON.parse(dataEl.textContent)||[]).filter(Boolean); }catch(e){}
    var inCart={}; (cart.items||[]).forEach(function(it){ inCart[it.product_id]=true; });
    var show=list.filter(function(u){ return !inCart[u.product_id]; }).slice(0,3);
    if(!cart.item_count||!show.length){ wrap.hidden=true; return; }
    wrap.hidden=false;
    items.innerHTML=show.map(function(u){
      return '<div class="cart-upsell__item"><a class="cart-upsell__thumb" href="'+esc(u.url)+'">'+(u.image?'<img src="'+esc(u.image)+'" width="56" height="70" alt="" loading="lazy">':'')+'</a><div class="cart-upsell__info"><a class="cart-upsell__title" href="'+esc(u.url)+'">'+esc(u.title)+'</a><span class="cart-upsell__price">'+money(u.price)+'</span></div><button type="button" class="btn btn--secondary btn--sm" data-upsell-add="'+esc(u.id)+'">'+t('add','Add')+'</button></div>';
    }).join('');
  }
  function renderDrawer(cart){ setCount(cart.item_count); var body=document.querySelector('[data-cart-drawer-body]'), foot=document.querySelector('[data-cart-drawer-footer]'); if(!body)return; renderProgress(cart); renderUpsells(cart); if(!cart.item_count){ body.innerHTML='<div class="state cart-drawer__empty"><h3 class="state__title">'+t('cart_empty','Your cart is empty')+'</h3><button type="button" class="btn btn--primary" data-close-layer>'+t('start_shopping','Start shopping')+'</button></div>'; if(foot)foot.hidden=true; return; } body.innerHTML=cart.items.map(lineHTML).join(''); if(foot){ foot.hidden=false; foot.innerHTML='<div class="cart-summary-row cart-summary-row--total"><span>'+t('subtotal','Subtotal')+'</span><span class="cart-summary__value">'+money(cart.total_price)+'</span></div><a class="btn btn--primary btn--full u-mt-4" href="'+ROOT+'checkout">'+t('checkout','Checkout')+'</a><button type="button" class="btn btn--ghost btn--full u-mt-2" data-close-layer>'+t('continue','Continue shopping')+'</button>'; } }
  function openCartDrawer(opener){ var d=document.getElementById('cart-drawer'); if(!d)return; Cart.get().then(function(c){ renderDrawer(c); openLayer(d,opener); }); }

  function addToCart(form, opener){
    if(!validatePersonalisation(form) || !validatePhoto(form)) return;
    Cart.add(form).then(function(res){
      if(res.status){ toast(res.description||res.message||t('error','Something went wrong — please try again'),'danger'); return; }
      /* Instant count feedback, even before the drawer render resolves */
      var pill=document.querySelector('[data-cart-count]');
      if(pill){ var cur=parseInt(pill.textContent,10)||0; var q=form.querySelector('[name=quantity]'); pill.textContent=cur+(q?Math.max(1,parseInt(q.value,10)||1):1); pill.hidden=false; }
      toast(t('added','Added to cart'));
      openCartDrawer(opener||form.querySelector('[type=submit]'));
    });
  }
  /* Add to cart without a form submit. Shopify's pixel layer reports a cart
     add for the submit AND again for the cart/add.js call, so every click sent
     Meta two AddToCart events. Cancelling the button's click means the form
     never submits: one add, one event. Without JS the button still submits
     the form as before. Enter in a field clicks the same button, so it is
     covered too. */
  document.addEventListener('click', function(e){
    var btn=e.target.closest('button[name="add"]'); if(!btn||btn.disabled)return;
    var form=btn.form; if(!form||!form.hasAttribute('data-product-form'))return;
    e.preventDefault();
    addToCart(form, btn);
  });
  document.addEventListener('submit', function(e){
    var form=e.target.closest('[data-product-form]'); if(!form)return;
    e.preventDefault();
    addToCart(form, form.querySelector('[type=submit]'));
  });
  /* Typed quantities: the drawer input had no listener at all, and the cart
     page only applied a typed value if the shopper found the Update button. */
  document.addEventListener('change', function(e){
    var inp=e.target.closest('[data-line-qty]'); if(!inp)return;
    var pageForm=inp.closest('#CartForm');
    if(pageForm){ pageForm.submit(); return; }
    Cart.change(inp.getAttribute('data-line-qty'), Math.max(0,parseInt(inp.value,10)||0)).then(renderDrawer);
  });
  document.addEventListener('click', function(e){
    /* Cart page steppers: adjust (generic stepper already changed the value),
       then submit the form so the server cart follows. */
    var pageStep=e.target.closest('#CartForm [data-qty-dec], #CartForm [data-qty-inc]');
    if(pageStep){ var f=pageStep.closest('form'); setTimeout(function(){ if(f)f.submit(); },60); return; }
    var t2=e.target.closest('[data-cart-open]'); if(t2){ e.preventDefault(); openCartDrawer(t2); return; }
    var up=e.target.closest('[data-upsell-add]');
    if(up){ up.disabled=true; fetch(ROOT+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:parseInt(up.getAttribute('data-upsell-add'),10),quantity:1})}).then(function(r){return r.json();}).then(function(){ Cart.get().then(renderDrawer); }).finally(function(){ up.disabled=false; }); return; }
    var inc=e.target.closest('[data-line-inc]'), dec=e.target.closest('[data-line-dec]'), rm=e.target.closest('[data-line-remove]');
    if(inc||dec||rm){ var key=(inc||dec||rm).getAttribute('data-line-inc')||(dec&&dec.getAttribute('data-line-dec'))||(rm&&rm.getAttribute('data-line-remove')); var input=document.querySelector('[data-line-qty="'+key+'"]'); var q=input?parseInt(input.value,10):1; if(inc)q++; if(dec)q--; if(rm)q=0; Cart.change(key,Math.max(0,q)).then(renderDrawer); }
  });

  /* ---- Product: gallery + variants + personalisation + sticky ---- */
  (function(){ var pdp=document.querySelector('[data-pdp]'); if(!pdp)return;
    var stageImg=pdp.querySelector('[data-pdp-stage-img]')||pdp.querySelector('[data-pdp-stage] img');
    // The stage takes the photo's own shape (4:5..3:2); keep it in step when a thumbnail swaps the photo in.
    var stageEl=pdp.querySelector('[data-pdp-stage]');
    if(stageImg&&stageEl){ stageImg.addEventListener('load',function(){ var w=stageImg.naturalWidth,h=stageImg.naturalHeight; if(!w||!h)return; stageEl.style.setProperty('--stage-ar',Math.min(1.5,Math.max(0.8,w/h)).toFixed(4)); }); }
    var thumbs=Array.prototype.slice.call(pdp.querySelectorAll('[data-pdp-thumb]'));
    var pdpPrev=pdp.querySelector('[data-pdp-prev]'), pdpNext=pdp.querySelector('[data-pdp-next]');
    function slot(th){ return th.closest('li')||th; }
    function shownThumbs(){ return thumbs.filter(function(t){ return !slot(t).hidden; }); }
    function currentThumb(){ return thumbs.filter(function(x){ return x.getAttribute('aria-current')==='true'; })[0]||null; }
    var stageSizes=(stageImg&&stageImg.getAttribute('sizes'))||'(min-width: 1024px) 50vw, 100vw';
    var calm=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* Bring a thumbnail into view inside its own strip. scrollIntoView moved the
       whole page as well: tapping a finish on a phone jumped the page ~450px up
       to the thumbnails, and nudged it ~60px on desktop. */
    function revealThumb(th){
      var list=th.closest('.pdp__thumbs'), li=slot(th); if(!list)return;
      var lr=list.getBoundingClientRect(), r=li.getBoundingClientRect(), dx=0, dy=0;
      if(list.scrollWidth>list.clientWidth){ if(r.left<lr.left)dx=r.left-lr.left; else if(r.right>lr.right)dx=r.right-lr.right; }
      if(list.scrollHeight>list.clientHeight){ if(r.top<lr.top)dy=r.top-lr.top; else if(r.bottom>lr.bottom)dy=r.bottom-lr.bottom; }
      if(dx||dy) list.scrollBy({left:dx,top:dy,behavior:calm?'auto':'smooth'});
    }
    function paint(th){
      if(!th)return;
      if(stageImg){
        /* A <picture> source in front of the img wins over anything set on the
           img below 1024px, which is why phones never saw the photo change.
           The section no longer renders one; this clears it from a page cached
           before that change. */
        var pic=stageImg.parentNode;
        if(pic&&pic.tagName==='PICTURE') Array.prototype.forEach.call(pic.querySelectorAll('source'),function(s){ s.remove(); });
        var set=th.getAttribute('data-srcset');
        if(set){ stageImg.setAttribute('sizes',stageSizes); stageImg.setAttribute('srcset',set); }
        else { stageImg.removeAttribute('srcset'); stageImg.removeAttribute('sizes'); }
        stageImg.src=th.getAttribute('data-full'); stageImg.alt=th.getAttribute('data-alt')||'';
      }
      thumbs.forEach(function(x){x.setAttribute('aria-current',String(x===th));});
      revealThumb(th);
    }
    /* show() is the one way the stage changes from a user action, so the
       colour chips follow whether the image was reached by clicking a
       thumbnail or by stepping through with the arrows. */
    function show(th){ if(!th)return; paint(th); selectColour(colourOf(th)); }
    function step(delta){
      var list=shownThumbs(); if(!list.length)return;
      var i=list.indexOf(currentThumb()); if(i<0)i=0;
      var n=(i+delta)%list.length; if(n<0)n+=list.length;
      show(list[n]);
    }
    thumbs.forEach(function(th){ th.addEventListener('click',function(){ show(th); }); });
    if(pdpPrev) pdpPrev.addEventListener('click',function(){ step(-1); });
    if(pdpNext) pdpNext.addEventListener('click',function(){ step(1); });
    /* Gallery and the colour/finish chips stay in step, but nothing is ever
       hidden: every image of every colour stays in the rail so the whole range
       is browsable. Clicking a gold photo selects Gold; picking Gold jumps the
       stage to the first gold photo. An image naming no colour (the size guide)
       leaves the selection alone. */
    function colourGroup(){
      var gs=pdp.querySelectorAll('[data-option]');
      for(var i=0;i<gs.length;i++){
        if(/colou?r|finish|material|\u0644\u0648\u0646|\u062a\u0634\u0637\u064a\u0628/i.test(gs[i].getAttribute('data-option')||'')) return gs[i];
      }
      return null;
    }
    /* Photos are matched by the English finish in their alt text or file name,
       but on /ar/ the chips read أسود / ذهبي / فضي, so nothing matched there:
       picking a finish left the photo alone and a photo never moved the chip.
       Chips are compared through this key. Keep it in step with the Arabic
       Finish values in Translate & Adapt and with main-product.liquid. The
       organisers add clear, wood, bamboo and walnut; their MDF stays "MDF". */
    var FINISH_KEY={'أسود':'black','ذهبي':'gold','فضي':'silver',
      'شفاف':'clear','خشب':'wood','خيزران':'bamboo','خشب الجوز':'walnut'};
    function keyOf(v){ v=(v||'').trim().toLowerCase(); return FINISH_KEY[v]||v; }
    function colourValues(){
      var g=colourGroup(); if(!g)return [];
      return Array.prototype.map.call(g.querySelectorAll('[data-value]'),function(b){
        return keyOf(b.getAttribute('data-value'));
      }).filter(Boolean);
    }
    /* Which colour does this thumbnail show? Longest match first, so "rose gold"
       is not mistaken for "gold" when both are offered. */
    function colourOf(th){
      var vals=colourValues().slice().sort(function(x,y){ return y.length-x.length; });
      var a=(th.getAttribute('data-alt')||'').toLowerCase();
      var hit=vals.filter(function(v){ return a.indexOf(v)>=0; })[0];
      if(hit) return hit;
      /* Alt text is hand-written and does not always name the finish — several
         products say "mirror chrome" where the option is called Silver, which
         left Silver unselectable while Black and Gold worked. The image
         filename always carries the finish, so fall back to it. Matched as
         "_silver" so a handle containing the word cannot trigger a false hit. */
      var u=(th.getAttribute('data-full')||'').toLowerCase();
      return vals.filter(function(v){ return u.indexOf('_'+v)>=0; })[0]||'';
    }
    function selectColour(val){
      var g=colourGroup(); if(!g||!val)return;
      var btns=Array.prototype.slice.call(g.querySelectorAll('[data-value]'));
      var target=btns.filter(function(b){
        return keyOf(b.getAttribute('data-value'))===val;
      })[0];
      if(!target||target.getAttribute('aria-pressed')==='true')return;
      btns.forEach(function(x){ x.setAttribute('aria-pressed',String(x===target)); });
      var disp=g.querySelector('[data-option-value-display]');
      if(disp) disp.textContent=target.getAttribute('data-value');
      updateVariant();
    }
    function showColour(val){
      if(!val)return;
      var match=thumbs.filter(function(t){ return colourOf(t)===val; })[0];
      if(match&&match!==currentThumb()) paint(match);
    }
    /* Size guide dialog. The size guide is the one image that does not change
       with the finish, so it is kept out of the rail and opened from here. */
    /* The dialog is rendered after the .pdp grid closes, so it is NOT inside
       pdp — look it up on the document. Scoping this to pdp silently found
       nothing and left the button dead. */
    var sg=document.querySelector('[data-sizeguide]');
    if(sg){
      var sgOpener=null;
      var sgOpen=function(btn){ sgOpener=btn||null; sg.hidden=false; document.body.style.overflow='hidden';
        var c=sg.querySelector('[data-sizeguide-close]'); if(c)c.focus(); };
      var sgClose=function(){ sg.hidden=true; document.body.style.overflow='';
        if(sgOpener&&sgOpener.focus)sgOpener.focus(); sgOpener=null; };
      pdp.querySelectorAll('[data-sizeguide-open]').forEach(function(b){
        b.addEventListener('click',function(){ sgOpen(b); }); });
      sg.querySelectorAll('[data-sizeguide-close]').forEach(function(b){
        b.addEventListener('click',sgClose); });
      sg.addEventListener('click',function(e){ if(e.target===sg)sgClose(); });
      document.addEventListener('keydown',function(e){ if(!sg.hidden&&e.key==='Escape')sgClose(); });
    }
    /* Zoom lightbox. The stage carried cursor:zoom-in for months with no
       handler behind it; clicking now opens a full-screen view of the current
       image at 2000px, stepping through the same list as the rail arrows. */
    var lb=document.querySelector('[data-lightbox]');
    if(lb&&stageImg){
      var lbImg=lb.querySelector('[data-lightbox-img]');
      var lbPrevB=lb.querySelector('[data-lightbox-prev]'), lbNextB=lb.querySelector('[data-lightbox-next]');
      var lbOpener=null;
      var lbPaint=function(){ var th=currentThumb()||shownThumbs()[0]; if(!th||!lbImg)return;
        lbImg.src=th.getAttribute('data-xl')||th.getAttribute('data-full'); lbImg.alt=th.getAttribute('data-alt')||''; };
      var lbOpen=function(op){ lbOpener=op||null; lbPaint(); lb.hidden=false; document.body.style.overflow='hidden';
        var c=lb.querySelector('[data-lightbox-close]'); if(c)c.focus(); };
      var lbClose=function(){ lb.hidden=true; document.body.style.overflow='';
        if(lbOpener&&lbOpener.focus)lbOpener.focus(); lbOpener=null; };
      var stage=pdp.querySelector('[data-pdp-stage]');
      if(stage) stage.addEventListener('click',function(){ lbOpen(stage); });
      lb.querySelectorAll('[data-lightbox-close]').forEach(function(btn){ btn.addEventListener('click',lbClose); });
      lb.addEventListener('click',function(e){ if(e.target===lb)lbClose(); });
      document.addEventListener('keydown',function(e){ if(lb.hidden)return;
        if(e.key==='Escape')lbClose();
        else if(e.key==='ArrowLeft'){ step(-1); lbPaint(); }
        else if(e.key==='ArrowRight'){ step(1); lbPaint(); } });
      if(lbPrevB) lbPrevB.addEventListener('click',function(){ step(-1); lbPaint(); });
      if(lbNextB) lbNextB.addEventListener('click',function(){ step(1); lbPaint(); });
      var lbMulti=thumbs.length>1;
      if(lbPrevB) lbPrevB.hidden=!lbMulti;
      if(lbNextB) lbNextB.hidden=!lbMulti;
    }

    // Nothing is filtered any more: make sure every thumbnail is on show.
    thumbs.forEach(function(t){ slot(t).hidden=false; });
    if(pdpPrev) pdpPrev.hidden=thumbs.length<2;
    if(pdpNext) pdpNext.hidden=thumbs.length<2;
    // Variant option chips -> update hidden variant id from product JSON
    var variantsEl=pdp.querySelector('[data-product-json]')||document.querySelector('[data-product-json]'); var variants=variantsEl?JSON.parse(variantsEl.textContent).variants:null;
    pdp.querySelectorAll('[data-option]').forEach(function(group){ group.querySelectorAll('[data-value]').forEach(function(b){ b.addEventListener('click',function(){ group.querySelectorAll('[data-value]').forEach(function(x){x.setAttribute('aria-pressed',String(x===b));}); var disp=group.querySelector('[data-option-value-display]'); if(disp)disp.textContent=b.getAttribute('data-value'); updateVariant(); if(group===colourGroup()) showColour(keyOf(b.getAttribute('data-value'))); }); }); });
    function currentVariant(){ if(!variants)return null; var idInput=pdp.querySelector('[data-variant-id]'); if(!idInput)return null; var id=parseInt(idInput.value,10); return variants.find(function(v){return v.id===id;})||null; }
    /* Availability follows the chosen variant: stocked variants say in-stock
       with the delivery window, everything else states the made-to-order lead
       time. The texts arrive pre-translated as data attributes, so this works
       on /ar/ without hard-coded English. */
    var availEl=pdp.querySelector('[data-pdp-availability]');
    var stockedEl=document.querySelector('[data-stocked-json]'); var stockedMap=null;
    try{ stockedMap=stockedEl?JSON.parse(stockedEl.textContent):null; }catch(err){}
    function paintAvailability(){
      if(!availEl)return; var v=currentVariant(); if(!v)return;
      var isStocked=!!(stockedMap&&stockedMap[String(v.id)]);
      var txt=availEl.querySelector('[data-avail-text]');
      if(txt) txt.textContent=isStocked?(availEl.getAttribute('data-stock-text')||''):(availEl.getAttribute('data-made-text')||'');
      availEl.classList.toggle('pdp__availability--made', !isStocked);
    }
    function paintTotal(){
      var v=currentVariant(); var qtyEl=pdp.querySelector('[data-qty-input]'); var qty=qtyEl?Math.max(1,parseInt(qtyEl.value,10)||1):1;
      var row=pdp.querySelector('[data-total-row]'), out=pdp.querySelector('[data-atc-total]');
      if(v&&row&&out){ out.textContent=money(v.price*qty); row.hidden=false; }
      var sp=document.querySelector('[data-sticky-price]'); if(v&&sp) sp.textContent=money(v.price);
      /* The headline price is rendered by Liquid as "From <lowest>" and used to
         sit there unchanged while the shopper picked a size, so a 120 cm piece
         still advertised the 40 cm price. Repaint it for the chosen variant. */
      var mp=pdp.querySelector('[data-pdp-price] .price__amount')||pdp.querySelector('[data-pdp-price]');
      if(v&&mp) mp.textContent=money(v.price);
      paintAvailability();
    }
    /* The address follows the choice (?variant=<id>), so a shared link, a
       refresh or the back button reopens the same size and finish, and the
       section opens on that finish's photo. */
    function rememberVariant(id){
      if(!id||!window.history||!history.replaceState||typeof URL!=='function')return;
      try{ var u=new URL(window.location.href); if(u.searchParams.get('variant')===String(id))return;
        u.searchParams.set('variant',String(id)); history.replaceState(history.state,'',u.toString()); }catch(err){}
    }
    /* The cart line carries the chosen finish's first photo. Always the first
       one, not whichever photo is on the stage, so adding Gold twice stays one
       line. A product with no finish option sends nothing and the cart keeps
       its own image. */
    var lineImg=pdp.querySelector('[data-line-image]'), lineDesign=pdp.querySelector('[data-line-design]');
    function paintLineImage(){
      if(!lineImg)return;
      var g=colourGroup(), on=g&&g.querySelector('[data-value][aria-pressed="true"]');
      var val=on?keyOf(on.getAttribute('data-value')):'';
      var mine=val?thumbs.filter(function(x){ return colourOf(x)===val; }):[], th=mine[0];
      var img=th&&th.querySelector('img');
      lineImg.value=(img&&img.getAttribute('src'))||'';
      lineImg.disabled=!lineImg.value;
      /* The factory designer gets the flat render of the same finish (the "_flat_" file),
         large, falling back to that finish's first photo. */
      if(lineDesign){
        var flat=mine.filter(function(x){ return /[_-]flat[_-]/i.test(x.getAttribute('data-xl')||''); })[0]||th;
        lineDesign.value=(flat&&flat.getAttribute('data-xl'))||'';
        lineDesign.disabled=!lineDesign.value;
      }
    }
    /* The size block states the finished width x height of the chosen size,
       and for a set each panel plus the whole set as hung. The shape comes
       from the product's size_spec (rendered as data attributes), so it
       follows every size change. Values read "60 cm", "40 cm each" or
       "40 سم", so the number is the leading figure. */
    var sizeInfo=pdp.querySelector('[data-size-info]');
    // The value is "length × breadth" ("120 × 69 cm", "60 × 60 cm each", "Ø 60 cm"); data-r over 1 means
    // the length runs top to bottom, and ow/oh scale one panel up to the whole set
    function paintSize(){
      if(!sizeInfo)return;
      var g=sizeInfo.closest('[data-option]'), on=g&&g.querySelector('[data-value][aria-pressed="true"]');
      var out=sizeInfo.querySelector('[data-size-dims]'), d=sizeInfo.dataset;
      var nums=((on&&on.getAttribute('data-value'))||'').match(/\d+(?:\.\d+)?/g)||[], l=parseFloat(nums[0]), b=nums.length>1?parseFloat(nums[1]):l;
      if(!out||!(l>0))return;
      var tall=(parseFloat(d.r)||1)>1, sw=Math.round((tall?b:l)*(parseFloat(d.ow)||1)), sh=Math.round((tall?l:b)*(parseFloat(d.oh)||1));
      var vals={l:Math.round(l), b:Math.round(b), n:d.n||'', ol:Math.max(sw,sh), ob:Math.min(sw,sh)};
      out.innerHTML=(d.tpl||'').replace(/\[(l|b|n|ol|ob)\]/g,function(_,k){ return esc(vals[k]); });
      var sp=sizeInfo.querySelector('[data-size-prop]');
      if(sp) sp.value=(sp.dataset.tpl||'').replace(/\[(l|b|n|ol|ob)\]/g,function(_,k){ return vals[k]; });
    }
    /* The free gift box card and its cart line follow the chosen size. data-boxes
       holds one {l, s, v} per Size value, in order, so the pressed chip's position
       picks the box; if the lengths disagree, the box with the chip's length wins.
       The struck price, the box size, the WhatsApp message and the "Gift box" line
       property are repainted from it. */
    var giftBox=pdp.querySelector('[data-giftbox]');
    function paintGiftBox(){
      if(!giftBox)return;
      var boxes; try{ boxes=JSON.parse(giftBox.dataset.boxes||'[]'); }catch(e){ return; }
      var g=pdp.querySelectorAll('[data-option]')[parseInt(giftBox.dataset.opt,10)];
      var chips=g?Array.prototype.slice.call(g.querySelectorAll('[data-value]')):[];
      var on=chips.filter(function(c){ return c.getAttribute('aria-pressed')==='true'; })[0];
      if(!on)return;
      giftBox.dataset.size=on.getAttribute('data-value');
      var n=parseFloat((on.getAttribute('data-value').match(/\d+(?:\.\d+)?/)||[])[0]), bx=boxes[chips.indexOf(on)];
      if(!bx||bx.l!==n) bx=boxes.filter(function(x){ return x.l===n; })[0]||bx;
      if(!bx)return;
      var price=money(bx.v*100), fill=function(tpl){ return (tpl||'').replace(/\[size\]/g,bx.s).replace(/\[price\]/g,price); };
      var was=giftBox.querySelector('[data-giftbox-was]'), desc=giftBox.querySelector('[data-giftbox-desc]'),
          wa=giftBox.querySelector('[data-giftbox-wa]'), prop=giftBox.querySelector('[data-giftbox-prop]');
      if(was) was.textContent=price;
      if(desc) desc.textContent=fill(giftBox.dataset.descTpl);
      if(wa) wa.href=giftBox.dataset.waBase+encodeURIComponent(fill(giftBox.dataset.waTpl));
      if(prop) prop.value=fill(prop.dataset.tpl);
    }
    /* Share for review: copies the product's own link with #reviews, with a short "copied"
       note beside the button so it can be pressed again. The Judge.me widget renders late and
       in its own Apps section, so the bar and the #reviews anchor are moved to just above it
       once it appears (the empty reviews holder in this section gives up the id). */
    var reviewBar=document.querySelector('[data-review-share-bar]'), reviewShare=reviewBar&&reviewBar.querySelector('[data-review-share]');
    if(reviewBar){
      var reviewTries=0;
      (function placeReviewShare(){
        var w=document.querySelector('.jdgm-review-widget,#judgeme_product_reviews,.jdgm-rev-widg');
        if(!w){ if(reviewTries++<40) setTimeout(placeReviewShare,250); return; }
        var holder=document.getElementById('reviews');
        if(holder&&!holder.contains(w)) holder.removeAttribute('id');
        if(!document.getElementById('reviews')){ var a=document.createElement('span'); a.id='reviews'; a.className='pdp-reviews__anchor'; w.parentNode.insertBefore(a,w); }
        w.parentNode.insertBefore(reviewBar,w); reviewBar.hidden=false;
        if(location.hash==='#reviews'){ try{ document.getElementById('reviews').scrollIntoView({behavior:'smooth',block:'start'}); }catch(e){} }
      })();
    }
    if(reviewShare){
      var reviewStatus=document.querySelector('[data-review-status]'), reviewTimer;
      reviewShare.addEventListener('click',function(){
        var url=location.origin+location.pathname+'#reviews';
        var done=function(){ if(!reviewStatus)return; reviewStatus.textContent=reviewShare.getAttribute('data-copied')+' ✓'; reviewStatus.classList.add('is-show'); clearTimeout(reviewTimer); reviewTimer=setTimeout(function(){ reviewStatus.classList.remove('is-show'); },1800); };
        var fallback=function(){ var t=document.createElement('textarea'); t.value=url; t.setAttribute('readonly',''); t.style.cssText='position:absolute;left:-9999px'; document.body.appendChild(t); t.select(); try{ document.execCommand('copy'); }catch(e){} document.body.removeChild(t); done(); };
        if(navigator.clipboard&&navigator.clipboard.writeText){ navigator.clipboard.writeText(url).then(done,fallback); } else { fallback(); }
      });
    }
    /* The gift box message (free): the counter shows how many of the 50
       characters are used, the lid preview shows the text, and the hidden "Box
       message" property carries it, enabled only when there is text. */
    var gbMsg=pdp.querySelector('[data-gb-msg]'), gbCount=pdp.querySelector('[data-gb-count]'), gbProp=pdp.querySelector('[data-gb-msg-prop]'), gbPreview=pdp.querySelector('[data-gb-preview]');
    function paintMessage(){
      if(!gbMsg)return; var v=gbMsg.value.trim();
      if(gbCount) gbCount.textContent=gbMsg.value.length;
      if(gbProp){ gbProp.value=v; gbProp.disabled=!v; }
      if(gbPreview){ gbPreview.textContent=v||gbPreview.getAttribute('data-empty'); gbPreview.classList.toggle('is-empty',!v); gbPreview.classList.toggle('is-long',v.length>34); gbPreview.hidden=false; }
    }
    if(gbMsg){ gbMsg.addEventListener('input',paintMessage); paintMessage(); }
    function updateVariant(){ if(!variants)return; var chosen=[]; pdp.querySelectorAll('[data-option]').forEach(function(g){ var s=g.querySelector('[data-value][aria-pressed="true"]'); chosen.push(s?s.getAttribute('data-value'):null); }); var match=variants.find(function(v){ return chosen.every(function(val,i){ return val==null||v.options[i]===val; }); }); var idInput=pdp.querySelector('[data-variant-id]'); if(match&&idInput){ idInput.value=match.id; rememberVariant(match.id); } paintLineImage(); paintSize(); paintGiftBox(); paintTotal(); }
    var qtyInput=pdp.querySelector('[data-qty-input]');
    if(qtyInput){ ['input','change'].forEach(function(ev){ qtyInput.addEventListener(ev,paintTotal); }); pdp.addEventListener('click',function(e){ if(e.target.closest('[data-qty-inc]')||e.target.closest('[data-qty-dec]')) setTimeout(paintTotal,0); }); }
    paintLineImage(); paintSize(); paintGiftBox(); paintTotal();
    // Buy It Now: add via AJAX (validations included), then straight to checkout
    var bin=pdp.querySelector('[data-buy-now]'), form=pdp.querySelector('[data-product-form]');
    if(bin&&form){ bin.addEventListener('click',function(){ if(!validatePersonalisation(form)||!validatePhoto(form))return; bin.setAttribute('aria-busy','true'); Cart.add(form).then(function(res){ if(res.status){ bin.removeAttribute('aria-busy'); toast(res.description||res.message||t('error','Something went wrong — please try again'),'danger'); return; } window.location.href=ROOT+'checkout'; }).catch(function(){ bin.removeAttribute('aria-busy'); }); }); }
    // Gift toggle: enable/disable hidden fields so non-gift orders carry no blanks
    var gift=pdp.querySelector('[data-gifting]');
    if(gift){ var gtoggle=gift.querySelector('[data-gift-toggle]'), gfields=gift.querySelector('[data-gift-fields]');
      if(gtoggle&&gfields){ gtoggle.addEventListener('change',function(){ var on=gtoggle.checked; gfields.hidden=!on; gfields.querySelectorAll('input,textarea').forEach(function(i){ i.disabled=!on; }); }); } }
    // Sticky ATC
    var sticky=document.querySelector('[data-pdp-sticky]'), mainAdd=pdp.querySelector('[data-pdp-add]');
    if(sticky&&mainAdd&&'IntersectionObserver'in window){ new IntersectionObserver(function(en){ var vis=!en[0].isIntersecting; sticky.classList.toggle('is-visible',vis); sticky.setAttribute('aria-hidden',String(!vis)); },{rootMargin:'0px 0px -40% 0px'}).observe(mainAdd); }
  })();
  function validatePhoto(form){
    var box=form.querySelector('[data-photo-upload]'); if(!box)return true;
    var input=box.querySelector('[data-photo-input]'), err=box.querySelector('[data-photo-error]');
    if(!input)return true;
    var maxMb=parseInt(box.getAttribute('data-max-mb')||'5',10);
    if(input.required&&!input.files.length){ if(err){err.textContent=t('upload_error_type','Please upload a JPG, PNG or WebP image.');err.hidden=false;} input.focus(); return false; }
    if(input.files.length){ var f=input.files[0];
      if(['image/jpeg','image/png','image/webp'].indexOf(f.type)===-1){ if(err){err.textContent=t('upload_error_type','Please upload a JPG, PNG or WebP image.');err.hidden=false;} return false; }
      if(f.size>maxMb*1024*1024){ if(err){err.textContent=t('upload_error_size','Image is too large — max [size] MB.').replace('[size]',maxMb);err.hidden=false;} return false; } }
    if(err)err.hidden=true; return true;
  }
  function validatePersonalisation(form){ var p=form.querySelector('[data-personalise]')||document.querySelector('[data-personalise]'); if(!p)return true; var req=p.querySelector('[data-prop][required]'); var cf=p.querySelector('[data-confirm]'); var err=p.querySelector('[data-personalise-error]'); if(req&&!req.value.trim()){ if(err){err.textContent=t('err_text','Please add your personalisation text.');err.hidden=false;} req.focus(); return false; } if(cf&&!cf.checked){ if(err){err.textContent=t('err_confirm','Please confirm your personalisation details.');err.hidden=false;} cf.focus(); return false; } if(err)err.hidden=true; return true; }

  /* ---- Predictive search (Shopify) ---- */
  (function(){ var overlay=document.getElementById('search-overlay'); if(!overlay)return; var input=overlay.querySelector('[data-search-input]'), results=overlay.querySelector('[data-search-results]'); if(!input||!results)return; var timer=null;
    input.addEventListener('input',function(){ clearTimeout(timer); var q=input.value.trim(); if(q.length<2){results.innerHTML='';return;} timer=setTimeout(function(){
      fetch(ROOT+'search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product,collection,article&resources[limit]=6',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(data){
        var rr=data.resources.results, html='';
        if(rr.products&&rr.products.length){ html+='<div class="search-group"><h2 class="search-group__heading">'+t('products','Products')+'</h2><ul class="search-suggestions">'+rr.products.map(function(p){return '<li class="search-suggestion"><a href="'+esc(p.url)+'"><span class="search-suggestion__thumb">'+(p.image?'<img src="'+esc(p.image)+'" width="44" height="44" alt="'+esc(p.title)+'">':'')+'</span><span class="search-suggestion__title">'+esc(p.title)+'</span></a></li>';}).join('')+'</ul></div>'; }
        if(rr.collections&&rr.collections.length){ html+='<div class="search-group"><h2 class="search-group__heading">'+t('collections','Collections')+'</h2><ul class="search-suggestions">'+rr.collections.map(function(c){return '<li class="search-suggestion"><a href="'+esc(c.url)+'">'+esc(c.title)+'</a></li>';}).join('')+'</ul></div>'; }
        if(!html){ html='<div class="state"><h2 class="state__title">'+t('no_results','No results')+'</h2></div>'; }
        results.innerHTML=html;
      }).catch(function(){});
    },160); });
  })();

  /* ---- Facets: apply immediately when a checkbox changes ---- */
  document.addEventListener('change', function(e){
    var form=e.target.closest('#FacetForm'); if(!form)return;
    if(e.target.type==='checkbox') form.submit();
  });

  /* ---- Collection filter drawer: relocate the single facet form ---- */
  (function(){ var drawer=document.getElementById('filter-drawer'), rail=document.querySelector('[data-filter-home]'), slot=drawer&&drawer.querySelector('[data-filter-slot]'), form=document.getElementById('FacetForm'); if(!(drawer&&rail&&slot&&form))return; new MutationObserver(function(){ if(drawer.getAttribute('data-open')==='true'){ slot.appendChild(form); } else if(form.parentNode===slot){ rail.appendChild(form); } }).observe(drawer,{attributes:true,attributeFilter:['data-open']}); })();

  /* ---- Consent (Shopify Customer Privacy API) ---- */
  (function(){ var banner=document.querySelector('[data-consent-banner]'); if(!banner)return;
    var api=window.Shopify&&Shopify.customerPrivacy;
    function shouldShow(){ try{ return api?api.shouldShowBanner():localStorage.getItem('acryhome-consent')==null; }catch(e){ return true; } }
    if(shouldShow()) banner.hidden=false; else banner.hidden=true;
    banner.addEventListener('click',function(e){ var a=e.target.closest('[data-consent-accept]'), r=e.target.closest('[data-consent-reject]'); if(!a&&!r)return; var grant=!!a; try{ if(api){ api.setTrackingConsent({analytics:grant,marketing:grant,preferences:grant,sale_of_data:grant?'yes':'no'},function(){}); } localStorage.setItem('acryhome-consent',grant?'accept':'reject'); }catch(err){} banner.hidden=true; });
  })();

  /* ---- Announcement rotator ---- */
  (function(){
    var rot=document.querySelector('[data-announcement-rotator]'); if(!rot)return;
    var slides=rot.querySelectorAll('.announcement__slide'); if(slides.length<2)return;
    if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    var i=0, iv=Math.max(3,parseInt(rot.getAttribute('data-interval')||'5',10))*1000, timer=null, paused=false;
    function next(){ if(paused||document.hidden)return; slides[i].classList.remove('is-active'); i=(i+1)%slides.length; slides[i].classList.add('is-active'); }
    function start(){ if(!timer) timer=setInterval(next,iv); }
    rot.addEventListener('mouseenter',function(){paused=true;}); rot.addEventListener('mouseleave',function(){paused=false;});
    rot.addEventListener('focusin',function(){paused=true;}); rot.addEventListener('focusout',function(){paused=false;});
    start();
  })();

  /* ---- Related products: lazy fetch via Product Recommendations API ---- */
  (function(){
    var wrap=document.querySelector('[data-recommendations]'); if(!wrap)return;
    var url=wrap.getAttribute('data-url'); if(!url)return;
    function load(){
      fetch(url).then(function(r){return r.text();}).then(function(html){
        var doc=new DOMParser().parseFromString(html,'text/html');
        var inner=doc.querySelector('[data-recommendations]');
        if(inner&&inner.innerHTML.trim()){ wrap.innerHTML=inner.innerHTML; wrap.hidden=false; }
      }).catch(function(){});
    }
    if('IntersectionObserver'in window){
      var io=new IntersectionObserver(function(en){ if(en[0].isIntersecting){ io.disconnect(); load(); } },{rootMargin:'400px 0px'});
      io.observe(wrap);
    } else { load(); }
  })();

  /* ---- Recently viewed (localStorage) ---- */
  (function(){
    var KEY='acryhome-recently-viewed', MAX=8;
    var read=function(){ try{ return JSON.parse(localStorage.getItem(KEY))||[]; }catch(e){ return []; } };
    var dataEl=document.querySelector('[data-rv-product]');
    if(dataEl){ try{ var p=JSON.parse(dataEl.textContent); var list=read().filter(function(x){return x.handle!==p.handle;}); list.unshift(p); localStorage.setItem(KEY,JSON.stringify(list.slice(0,MAX))); }catch(e){} }
    var wrap=document.querySelector('[data-recently-viewed]'), grid=document.querySelector('[data-recently-viewed-grid]');
    if(!wrap||!grid)return;
    var current=wrap.getAttribute('data-current-handle');
    /* Stored entries outlive the products. A piece that has since been archived
       or unpublished kept appearing here and linked to a 404, so every candidate
       is checked against the storefront before it is shown, and dead ones are
       dropped from storage so the check is not repeated. */
    var candidates=read().filter(function(x){ return x.handle!==current; }).slice(0,MAX);
    if(!candidates.length)return;
    Promise.all(candidates.map(function(x){
      return fetch('/products/'+encodeURIComponent(x.handle)+'.js',{headers:{'Accept':'application/json'}})
        .then(function(r){ return r.ok?x:null; })
        .catch(function(){ return x; });   // offline: keep it rather than wrongly pruning
    })).then(function(checked){
      var live=checked.filter(Boolean);
      try{ localStorage.setItem(KEY, JSON.stringify(live.slice(0,MAX))); }catch(e){}
      paint(live.slice(0,4));
    });
    function paint(items){
    if(!items.length)return;
    grid.innerHTML=items.map(function(x){
      return '<article class="product-card"><a class="product-card__media" href="'+esc(x.url)+'">'+(x.image?'<img src="'+esc(x.image)+'" alt="'+esc(x.title)+'" width="600" height="750" loading="lazy">':'')+'</a><div class="product-card__body"><h3 class="product-card__title"><a href="'+esc(x.url)+'">'+esc(x.title)+'</a></h3><span class="price"><span class="price__amount">'+money(x.price)+'</span></span></div></article>';
    }).join('');
    wrap.hidden=false;
    }
  })();

  /* ---- Wishlist (localStorage) ---- */
  (function(){
    var KEY='acryhome-wishlist';
    function read(){ try{ return JSON.parse(localStorage.getItem(KEY))||[]; }catch(e){ return []; } }
    function write(list){ try{ localStorage.setItem(KEY,JSON.stringify(list)); }catch(e){} paintCounts(list); }
    function has(list,handle){ return list.some(function(x){ return x.handle===handle; }); }
    function paintCounts(list){ list=list||read(); document.querySelectorAll('[data-wishlist-count]').forEach(function(el){ el.textContent=list.length; el.hidden=list.length===0; }); }
    function paintButtons(){
      var list=read();
      document.querySelectorAll('[data-wishlist-toggle]').forEach(function(btn){
        var item; try{ item=JSON.parse(btn.getAttribute('data-wishlist-item')); }catch(e){ return; }
        var active=has(list,item.handle);
        btn.setAttribute('aria-pressed',String(active));
        btn.setAttribute('aria-label', active?t('wishlist_remove','Remove from wishlist'):t('wishlist_add','Add to wishlist'));
        var lbl=btn.querySelector('[data-wishlist-label]'); if(lbl) lbl.textContent=active?t('wishlist_remove','Remove from wishlist'):t('wishlist_add','Add to wishlist');
      });
    }
    document.addEventListener('click',function(e){
      var btn=e.target.closest('[data-wishlist-toggle]'); if(!btn)return;
      e.preventDefault();
      var item; try{ item=JSON.parse(btn.getAttribute('data-wishlist-item')); }catch(err){ return; }
      var list=read();
      if(has(list,item.handle)){ list=list.filter(function(x){ return x.handle!==item.handle; }); toast(t('wishlist_removed','Removed from wishlist')); }
      else { list.unshift(item); toast(t('wishlist_saved','Saved to wishlist')); }
      write(list); paintButtons(); renderPage();
    });
    function renderPage(){
      var grid=document.querySelector('[data-wishlist-grid]'), empty=document.querySelector('[data-wishlist-empty]');
      if(!grid)return;
      var list=read();
      if(!list.length){ grid.hidden=true; grid.innerHTML=''; if(empty)empty.hidden=false; return; }
      if(empty)empty.hidden=true; grid.hidden=false;
      grid.innerHTML=list.map(function(x){
        return '<article class="product-card"><button type="button" class="product-card__wishlist" data-wishlist-toggle aria-pressed="true" aria-label="'+esc(t('wishlist_remove','Remove from wishlist'))+'" data-wishlist-item=\''+esc(JSON.stringify(x))+'\'><svg class="icon icon--sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20s-7-4.5-9-9a4.5 4.5 0 0 1 9-2 4.5 4.5 0 0 1 9 2c-2 4.5-9 9-9 9Z"/></svg></button><a class="product-card__media" href="'+esc(x.url)+'">'+(x.image?'<img src="'+esc(x.image)+'" alt="'+esc(x.title)+'" width="600" height="750" loading="lazy">':'')+'</a><div class="product-card__body"><h3 class="product-card__title"><a href="'+esc(x.url)+'">'+esc(x.title)+'</a></h3><span class="price"><span class="price__amount">'+money(x.price)+'</span></span></div></article>';
      }).join('');
      paintButtons();
    }
    paintCounts(); paintButtons(); renderPage();
  })();

  /* ---- Featured tabs: switch + lazy fetch ---- */
  (function(){
    document.querySelectorAll('[data-tabs]').forEach(function(tabs){
      var buttons=tabs.querySelectorAll('[data-tab]'), panels=tabs.querySelectorAll('[data-tab-panel]');
      buttons.forEach(function(btn,i){
        btn.addEventListener('click',function(){
          buttons.forEach(function(b,j){ b.setAttribute('aria-selected',String(j===i)); });
          panels.forEach(function(p,j){ p.hidden=j!==i; });
          var panel=panels[i], src=panel&&panel.getAttribute('data-tab-src');
          if(src){ panel.removeAttribute('data-tab-src');
            fetch(src).then(function(r){ return r.text(); }).then(function(html){
              var doc=new DOMParser().parseFromString(html,'text/html');
              var grid=doc.querySelector('.grid--products'), target=panel.querySelector('[data-tab-target]');
              if(grid&&target){ grid.className='featured-tabs__rail'; target.replaceWith(grid); }
            }).catch(function(){});
          }
        });
      });
    });
  })();

  /* ---- PDP intro: read more / less ---- */
  (function(){
    var intro=document.querySelector('[data-pdp-intro]'); if(!intro)return;
    var btn=intro.querySelector('[data-readmore]'); if(!btn)return;
    var lbl=btn.querySelector('[data-readmore-label]');
    btn.addEventListener('click',function(){
      var open=intro.classList.toggle('is-open');
      btn.setAttribute('aria-expanded',String(open));
      if(lbl) lbl.textContent=open?t('read_less','Read less'):t('read_more','Read more');
    });
  })();

  /* ---- Product rail arrows (delegated: survives lazy tab replacement) ---- */
  document.addEventListener('click', function(e){
    var prev=e.target.closest('[data-rail-prev]'), next=e.target.closest('[data-rail-next]');
    if(!prev&&!next)return;
    var wrap=(prev||next).closest('[data-rail-wrap]'); if(!wrap)return;
    var rail=wrap.querySelector('.featured-tabs__rail'); if(!rail)return;
    var dir=(document.documentElement.dir==='rtl')?-1:1;
    var step=rail.clientWidth*(prev?-1:1)*dir;
    rail.scrollBy({left:step,behavior:'smooth'});
  });

  /* ---- Contact form honeypot ---- */
  document.addEventListener('submit', function(e){
    var form=e.target.closest('.contact-form'); if(!form)return;
    var hp=form.querySelector('[data-honeypot]');
    if(hp&&hp.value){ e.preventDefault(); }
  });

  /* ---- Theme Editor support ---- */
  document.addEventListener('shopify:section:load', function(){ /* re-init hooks would go here; delegated listeners already cover most */ });
})();
